<div class="fe-checkbox" [ngClass]="{'fe-toggle-text-left': textDirection === 'LEFT'}">
    <mat-checkbox [(ngModel)]="inputValue" (change)="this.valueChange.emit(inputValue)"
                  [indeterminate]="indeterminate" class="fe-checkbox"/>
    <span class="fe-toggle-text bigText" [class.bold]="bold" *ngIf="text != ''">{{text}}</span>
</div>